import { render, staticRenderFns } from "./dealerhospitalmaintenanceindicatorstable.vue?vue&type=template&id=4bdab508&scoped=true&"
import script from "./dealerhospitalmaintenanceindicatorstable.vue?vue&type=script&lang=js&"
export * from "./dealerhospitalmaintenanceindicatorstable.vue?vue&type=script&lang=js&"
import style0 from "./dealerhospitalmaintenanceindicatorstable.vue?vue&type=style&index=0&id=4bdab508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdab508",
  null
  
)

export default component.exports